module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'absence',
        // showHead: true,
        // showIDs: true,
        showTDVerticalTop: true,
        lazyloadStepSize: 10,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '34px',
        },
        rowActions: {
            // edit: true,
            customs: [
                {
                    buttonType: 'delete',
                    neutral: true,
                    // privilegeCode: 'bo_absence:delete'
                },
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_absence': true,
            'resourceChanged.bo_employees': true,
        }
    },

    model: {
        resourceFilters: {
            // order: [{
            //     fieldCode: 'timeRange',
            //     direction: 'desc'
            // }]
        }
    },

    methods: {
        // onPrepareDone(){
        //     this.config.customHeadActionsFormMapping = {
        //         buttons: [
        //             { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
        //         ]
        //     }
        // },

        onResourceSanitized(){
            this.storeLoadedStatusIDs()

            this.locate('< templates_core_controller_controller > templates_crew_absence_summary', summary => {
                if(summary.$.length) {
                    summary.refresh()
                }
            })
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const myEmployeeID  = (((((storage || {}).user || {}).data || {}).userTableAssociates || {}).employee || {}).employeeID

            if(refreshers[key] && (
                (key === 'reconnect') ||
                (key === 'resourceChanged.bo_absence') ||
                (key === 'resourceChanged.bo_employees' && myEmployeeID && myEmployeeID == (message.data.primaryKey || message.data.employeeID))
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },
}